<template>
  <div class="m-5 pb-5">
    <ButtonPanel :buttonIcon="'refresh'" :click="refresh" icon="speaker_notes" :title="$t(`message.openEntries`)">
      <div v-if="openReviewEntry.isLoading.value" class="flex justify-center items-center" style="height: 120px">
        <LoadingPanel />
      </div>
      <div v-else>
        <div v-if="openReviewEntry.hasEntryInList.value">
          <ReviewEntryHeader />
          <div v-for="(entry, index) in openReviewEntry.entryList.value" :key="index" class="w-full">
            <ReviewEntryElement
              :entry="entry"
              :entryType="'OPEN'"
              :index="index"
              :length="openReviewEntry.entryList.value.length"
            />
          </div>
        </div>
        <div v-else class="px-4 py-3">
          {{ $t('message.noData') }}
        </div>
      </div>
    </ButtonPanel>
    <BasePanel class="mt-5" icon="speaker_notes_off" :title="$t(`message.closedEntries`)">
      <div v-if="closeReviewEntry.isLoading.value" class="flex justify-center items-center" style="height: 120px">
        <LoadingPanel />
      </div>
      <div v-else>
        <div v-if="closeReviewEntry.hasEntryInList.value">
          <ReviewEntryHeader />
          <div v-for="(entry, index) in closeReviewEntry.entryList.value" :key="index" class="w-full">
            <ReviewEntryElement
              :entry="entry"
              :entryType="'CLOSE'"
              :index="index"
              :length="closeReviewEntry.entryList.value.length"
            />
          </div>
        </div>
        <div v-else class="px-4 py-3">
          {{ $t('message.noData') }}
        </div>
      </div>
    </BasePanel>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'

import LoadingPanel from '@/presentation/components/Loading/LoadingPanel.vue'
import BasePanel from '@/presentation/components/Panel/BasePanel.vue'
import ButtonPanel from '@/presentation/components/Panel/ButtonPanel.vue'
import ReviewEntryElement from '@/presentation/components/Review/children/ReviewEntryElement.vue'
import ReviewEntryHeader from '@/presentation/components/Review/children/ReviewEntryHeader.vue'
import { useAuthStatePresenter } from '@/presentation/composables/auth/useAuthStatePresenter'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'
import { useProblemStatePresenter } from '@/presentation/composables/problem/useProblemStatePresenter'
import { useCloseReviewEntryPresenter } from '@/presentation/composables/review/useCloseReviewEntryPresenter'
import { useOpenReviewEntryPresenter } from '@/presentation/composables/review/useOpenReviewEntryPresenter'
import { useReviewPageStatePresenter } from '@/presentation/composables/review/useReviewPageStatePresenter'
import { useReviewPresenter } from '@/presentation/composables/review/useReviewPresenter'

export default defineComponent({
  components: {
    ButtonPanel,
    BasePanel,
    LoadingPanel,
    ReviewEntryHeader,
    ReviewEntryElement
  },
  setup(_, ctx) {
    const authStatePresenter = useAuthStatePresenter()
    const { problemId } = useProblemStatePresenter()
    const { isLightMode } = useConfigStatePresenter()
    const { initState } = useReviewPresenter()
    const openReviewEntry = useOpenReviewEntryPresenter()
    const closeReviewEntry = useCloseReviewEntryPresenter()
    const { isFirstOpendPage, setIsFirstOpendPage } = useReviewPageStatePresenter()

    const userId = authStatePresenter.user.value.id

    const refresh = () => {
      initState(userId, problemId.value)
    }

    if (isFirstOpendPage.value) refresh()

    onMounted(() => {
      setIsFirstOpendPage(false)
    })

    return { refresh, isLightMode, openReviewEntry, closeReviewEntry }
  }
})
</script>

<style lang="postcss" scoped>
.select {
  user-select: none;
}

.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s ease-out;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
